/** Percentage computation mode for balance report income rows */
export enum BalanceReportIncomePercentModeEnum {
  /** Percentage of total income */
  OF_TOTAL_INCOME = 'OF_TOTAL_INCOME',
  /** Percentage of direction kinds */
  OF_CLASSIFICATION = 'OF_DIRECOF_CLASSIFICATIONION_KINDS',
}
